// src/components/insights/figureCounter.js

let counter = 0;

export function getNextFigureNumber() {
  counter += 1;
  return counter;
}

export function resetFigureCounter() {
  counter = 0;
}